'use strict';

// Setting up route
angular.module('core').config([
  '$stateProvider', '$urlRouterProvider',
  function ($stateProvider, $urlRouterProvider) {
    // Redirect to home view when route not found
    $urlRouterProvider.otherwise('/');

    // Home state routing
    $stateProvider.
      state('contact', {
        url        : '/contact',
        templateUrl: 'modules/core/views/contact.client.view.html'
      }).
      state('copyright', {
        url        : '/copyright',
        templateUrl: 'modules/core/views/copyright.client.view.html'
      }).
      state('terms', {
        url        : '/terms',
        template   : '',
        controller : 'RedirectController'
      }).
      state('privacy', {
        url        : '/privacy',
        template   : '',
        controller : 'RedirectController'
      }).
      state('imprint', {
        url        : '/imprint',
        template   : '',
        controller : 'RedirectController'
      }).
      state('faq', {
        url        : '/faq',
        template   : '',
        controller : 'RedirectController'
      }).
      state('about', {
        url        : '/about',
        templateUrl: 'modules/core/views/about.client.view.html'
      }).
      state('features', {
        url        : '/features',
        templateUrl: 'modules/core/views/features.client.view.html'
      }).
      state('supportedLanguage', {
        url        : '/supported-machine-translations',
        templateUrl: 'modules/core/views/supported-language.client.view.html'
      }).
      state('accountLocked', {
        url        : '/account-locked/:type/:lockedUser',
		controller : 'AccountLockedController',
        templateUrl: 'modules/core/views/account-locked.client.view.html'
      }).
      state('home', {
        url        : '/',
        templateUrl: 'modules/core/views/home.client.view.html'
      });
  }
]);
